import React from "react";
import { Input, TextArea, DateInput } from "../../../../../../common/Input";
import { EmployeePickerField } from "../../../../../../common/selectComponents/EmployeePicker";
import VesselPickerField from "../../../../../../common/selectComponents/VesselPicker";
import SectionBadge from "../../ui/SectionBadge";

const AssignmentDetailsTab = ({
  form,
  set,
  editable,
  errors,
  accessRules
}) => {
  const isAllowWithBenefitFeature = false;

  return (
    <div className="space-y-6">

      {(accessRules?.allowEffectiveFrom ||
        form.createdAt) && (
          <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
            <SectionBadge label="Assignment Details" editable={editable} />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-4 mb-3">

              {form.createdAt && (
                <>
                  <DateInput
                    label="Transaction Date:"
                    value={form.createdAt}
                    disabled={true}
                  />
                  <Input
                    label="Transaction Code:"
                    value={form.transactionCode || ""}
                    isDisabled={true}
                    placeholder="-- Auto Generated --"
                  />
                </>
              )}

              {accessRules?.allowEffectiveFrom && (
                <DateInput
                  label="Effective From:"
                  value={form.effectiveFrom}
                  onChange={e => set('effectiveFrom', e.target.value)}
                  disabled={!editable}
                  isRequired={true}
                  error={!!errors.effectiveFrom}
                  errorMessage={errors.effectiveFrom}
                />
              )}

            </div>
          </div>
        )}

      <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
        <SectionBadge label="Assignment Details" editable={editable} />
        {(accessRules?.allowDestinationHead ||
          (accessRules?.allowDestinationVessel && !form?.isOnLeave)) && (

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-4 mb-3">

              {accessRules?.allowDestinationHead && (
                <EmployeePickerField
                  label="Destination Head:"
                  employeePersonalInformationId={form.destinationHeadId}
                  displayValue={form.destinationHeadData?.fullName || ""}
                  onSelect={(emp) => { set('destinationHeadId', emp.id); set('destinationHeadData', { fullName: emp.fullName, employeeId: emp.employeeId, position: emp.employeeInformationPositionDescription || "N/A" }); }}
                  onClear={() => { set('destinationHeadId', ""); set('destinationHeadData', null); }}
                  viewMode={!editable}
                  allowClear={true}
                  isRequired={true}
                  error={!!errors.destinationHeadId}
                  errorMessage={errors.destinationHeadId}
                />
              )}

              {accessRules?.allowDestinationVessel &&
                !form?.isOnLeave && (
                  <VesselPickerField
                    label="Destination Vessel:"
                    vesselId={form.destinationVesselId}
                    displayValue={form.destinationVesselCode || "--Select--"}
                    onSelect={(v) => { set('destinationVesselId', v.id); set('destinationVesselCode', v.code); }}
                    onClear={() => { set('destinationVesselId', ""); set('destinationVesselCode', ""); }}
                    viewMode={!editable}
                    allowClear={true}
                    isRequired={!form?.isOnLeave}
                    error={!!errors.destinationVesselId && !form?.isOnLeave}
                    errorMessage={!form?.isOnLeave ? errors.destinationVesselId : null}
                  />
                )}
            </div>
          )}

        {accessRules?.allowRemarks && (
          <TextArea
            label="Remarks:"
            value={form.remarks || ""}
            onChange={e => set('remarks', e.target.value)}
            placeholder="Enter any additional instructions or remarks..."
            disabled={!editable}
            rows={2}
            isRequired={true}
            error={!!errors.remarks}
            errorMessage={errors.remarks}
          />
        )}

        {(accessRules?.allowIsActive ||
          accessRules?.allowOnLeave ||
          accessRules?.allowWithTime ||
          (accessRules?.allowWithTime && isAllowWithBenefitFeature)) && (
            <div className="flex flex-col md:flex-row gap-6">
              {accessRules?.allowIsActive && (
                <div className="pt-4 border-t border-gray-200">
                  <label className={`flex items-center gap-3 ${editable ? "cursor-pointer" : "cursor-not-allowed opacity-60"}`}>
                    <input type="checkbox" checked={!!form.isActive} onChange={e => set('isActive', e.target.checked)} disabled={!editable} className="w-4 h-4 accent-blue-600" />
                    <span className="text-sm font-medium text-gray-700">Is Active</span>
                  </label>
                </div>
              )}

              {accessRules?.allowOnLeave && (
                <div className="pt-4 border-t border-gray-200">
                  <label className={`flex items-center gap-3 ${editable ? "cursor-pointer" : "cursor-not-allowed opacity-60"}`}>
                    <input type="checkbox" checked={!!form.isOnLeave} onChange={e => set('isOnLeave', e.target.checked)} disabled={!editable} className="w-4 h-4 accent-blue-600" />
                    <span className="text-sm font-medium text-gray-700">Is On Leave</span>
                  </label>
                </div>
              )}

              {accessRules?.allowWithTime && (
                <div className="pt-4 border-t border-gray-200">
                  <label className={`flex items-center gap-3 ${editable ? "cursor-pointer" : "cursor-not-allowed opacity-60"}`}>
                    <input type="checkbox" checked={!!form.isWithTime} onChange={e => set('isWithTime', e.target.checked)} disabled={!editable} className="w-4 h-4 accent-blue-600" />
                    <span className="text-sm font-medium text-gray-700">w/time</span>
                  </label>
                </div>
              )}

              {accessRules?.allowWithBenefits && isAllowWithBenefitFeature && (
                <div className="pt-4 border-t border-gray-200">
                  <label className={`flex items-center gap-3 ${editable ? "cursor-pointer" : "cursor-not-allowed opacity-60"}`}>
                    <input type="checkbox" checked={!!form.isWithBenefits} onChange={e => set('isWithBenefits', e.target.checked)} disabled={!editable} className="w-4 h-4 accent-blue-600" />
                    <span className="text-sm font-medium text-gray-700">w/benefits</span>
                  </label>
                </div>
              )}

            </div>
          )}
      </div>
    </div>
  );
};

export default AssignmentDetailsTab;